/* CUS Studios loading screen
   Lightweight loader: hides as soon as the DOM is ready instead of waiting for every image/video/script. */
(function () {
  var overlayId = 'cus-page-preloader';
  var removeDelay = 300;

  function hidePreloader() {
    var overlay = document.getElementById(overlayId);

    if (!overlay || overlay.dataset.cusHidden === 'true') return;

    overlay.dataset.cusHidden = 'true';
    overlay.classList.add('cus-page-preloader--is-hidden');

    window.setTimeout(function () {
      if (overlay && overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    }, removeDelay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.requestAnimationFrame(hidePreloader);
    }, { once: true });
  } else {
    window.requestAnimationFrame(hidePreloader);
  }

  // Safety fallback in case DOMContentLoaded is delayed by an unusual third-party script.
  window.setTimeout(hidePreloader, 1800);

  // Handles browser back/forward cache safely without re-showing the loader.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      hidePreloader();
    }
  });
})();
